import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgJoystick = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "#000000",
	viewBox: "0 0 256 256",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M208,144H136V95.19a40,40,0,1,0-16,0V144H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V160A16,16,0,0,0,208,144ZM104,56a24,24,0,1,1,24,24A24,24,0,0,1,104,56ZM208,208H48V160H208v48Zm-40-96h32a8,8,0,0,1,0,16H168a8,8,0,0,1,0-16Z" })
});
export default SvgJoystick;
